import { AxiosError } from 'axios';
import api from '../../../services/api';

export async function deleteCapacityLevelRequest(id: number) {
	try {
		const response = await api.delete(`/capacityLevel/${id}`);

		return response.data;
	} catch (error) {
		if (error instanceof AxiosError) {
			throw new Error(error.response?.data?.message);
		} else {
			throw new Error();
		}
	}
}
